// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__JmgCU","loaderWrapper":"Loader_loaderWrapper__hdFwA"};